<template>
  <div>
    <!--sign in-->
    <div class="signin-section pt-60 pb-60">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <!--this is log in-->
            <div class="opent-code ss">
              <div class="popup-container">
                <div class="register-from">
                  <div class="head">
                    <h2>{{ $t("Register") }}</h2>
                    <p>{{ $t("Register With Email/Phone") }}</p>
                  </div>
                  <form action="javascript:;" @submit.prevent="onRegister">
                    <div class="items">
                      <div class="form-input">
                        <label for="name" class="form-label">{{
                          $t("Enter your name")
                        }}</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          v-model="name"
                          :placeholder="$t('Your name')"
                        />
                      </div>

                      <div class="form-input mt-2">
                        <label for="email" class="form-label">{{
                          $t("Enter your email")
                        }}</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          v-model="email"
                          :placeholder="$t('Your email')"
                        />
                      </div>

                      <div class="form-input mt-2">
                        <label for="name" class="form-label">{{
                          $t("Enter your phone")
                        }}</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          v-model="phone"
                          :placeholder="$t('Your phone')"
                        />
                      </div>
                    </div>

                    <div class="items mt-2">
                      <button
                        type="submit"
                        class="cmn--btn cd-popup-close repopup"
                      >
                        <span>{{ $t("Register") }}</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--sign in-->
  </div>
</template>

<script>
// import BreadcrumbBanner from "@/components/partials/Breadcumnd.vue";
import { mapActions, mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import helpers from "@/helpers";

export default {
  name: "RegisterPage",
  components: {
    // BreadcrumbBanner,
  },
  data() {
    return {
      name: "",
    };
  },
  computed: {
    ...mapState(useAuthStore, ["isLoggedIn", "userInfo"]),
  },
  methods: {
    ...mapActions(useAuthStore, ["register"]),
    async onRegister() {
      if(!this.name) {
        helpers.showToast(
          this.$t("Name is required"),
          this.$t("Register Failed"),
          "error"
        );
        return;
      }
      if(!this.phone) {
        helpers.showToast(
          this.$t("Phone number is required"),
          this.$t("Register Failed"),
          "error"
        );
        return;
      }
      if(!this.email) {
        helpers.showToast(
          this.$t("Email address is required"),
          this.$t("Register Failed"),
          "error"
        );
        return;
      }

      // Add your code here
      const response = await this.register(this.name, this.phone, this.email);
      if (response.success) {
        helpers.showToast(
          this.$t("Regsiteration Completed successfully"),
          this.$t("Regsiteration Completed"),
          "success"
        );
        const redirectUrl = localStorage.getItem("redirectUrl");
        if (redirectUrl && redirectUrl != "/user/login") {
          this.$router.push(redirectUrl);
        } else {
          this.$router.push({ name: "home" });
        }
      } else {
        helpers.showToast(
          this.$t("Failed to register"),
          this.$t("Regsiteration Failed"),
          "error"
        );
      }
    },
  },
  mounted() {
    // if the user is already logged in, redirect to home page
    if (this.isLoggedIn) {
      this.$router.push({ name: "home" });
    }
  },
};
</script>
